"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CognitoConfirmForgotPassword = exports.CognitoForgotPassword = exports.CognitoVerifyOtp = exports.CognitoNewPasswordRequired = exports.CognitoLogin = void 0;
const cognitoLoginDomain = __importStar(require("./cognito-login/cognito-login-domain"));
const cognitoNewPasswordRequiredDomain = __importStar(require("./cognito-login/new-password-required-domain"));
const cognitoVerifyOtpDomain = __importStar(require("./cognito-login/verify-otp-domain"));
const cognitoForgotPasswordDomain = __importStar(require("./forgot-password/forgot-password-domain"));
const cognitoConfirmForgotPasswordDomain = __importStar(require("./forgot-password/confirm-forgot-password"));
__exportStar(require("./common/enums"), exports);
__exportStar(require("./common/MOLAdmin"), exports);
__exportStar(require("./common/MOLAdminComplete"), exports);
__exportStar(require("./common/MOLAdminIdentity"), exports);
var CognitoLogin;
(function (CognitoLogin) {
    CognitoLogin.method = "POST";
    CognitoLogin.route = "/admin-authforwarder/api/user/cognito-login";
    CognitoLogin.Domain = cognitoLoginDomain;
})(CognitoLogin || (exports.CognitoLogin = CognitoLogin = {}));
var CognitoNewPasswordRequired;
(function (CognitoNewPasswordRequired) {
    CognitoNewPasswordRequired.method = "POST";
    CognitoNewPasswordRequired.route = "/admin-authforwarder/api/user/new-password-required";
    CognitoNewPasswordRequired.Domain = cognitoNewPasswordRequiredDomain;
})(CognitoNewPasswordRequired || (exports.CognitoNewPasswordRequired = CognitoNewPasswordRequired = {}));
var CognitoVerifyOtp;
(function (CognitoVerifyOtp) {
    CognitoVerifyOtp.method = "POST";
    CognitoVerifyOtp.route = "/admin-authforwarder/api/user/otp";
    CognitoVerifyOtp.Domain = cognitoVerifyOtpDomain;
})(CognitoVerifyOtp || (exports.CognitoVerifyOtp = CognitoVerifyOtp = {}));
var CognitoForgotPassword;
(function (CognitoForgotPassword) {
    CognitoForgotPassword.method = "POST";
    CognitoForgotPassword.route = "/admin-authforwarder/api/user/forgot-password";
    CognitoForgotPassword.Domain = cognitoForgotPasswordDomain;
})(CognitoForgotPassword || (exports.CognitoForgotPassword = CognitoForgotPassword = {}));
var CognitoConfirmForgotPassword;
(function (CognitoConfirmForgotPassword) {
    CognitoConfirmForgotPassword.method = "POST";
    CognitoConfirmForgotPassword.route = "/admin-authforwarder/api/user/confirm-forgot-password";
    CognitoConfirmForgotPassword.Domain = cognitoConfirmForgotPasswordDomain;
})(CognitoConfirmForgotPassword || (exports.CognitoConfirmForgotPassword = CognitoConfirmForgotPassword = {}));
//# sourceMappingURL=index.js.map